import { BestActionResultV2Fragment } from 'services/graphql/fragments/Fragments';
import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const WhereToGo = gql`
  query WhereToGo {
    whereToGo {
      __typename
      ... on GoToServicing {
        id
        customerStatus
        tours {
          id
          type
        }
        screenTakeovers {
          id
          type
          title
          body
          actions {
            copy
            link
            type
          }
        }
      }
      ... on GoToNextBestActionV2 {
        __typename
        id
        type
        bestAction {
          ...BestActionResultV2Fragment
        }
      }
      ... on GoToOnboarding {
        id
        bankApplicationStatus
      }
      ... on GoToDecision {
        id
        bankApplicationStatus
      }
      ... on GoToIdvRequest {
        id
        requests {
          id
          description
          mechanism
          qrCode
          type
          url
          name
        }
      }
      ... on GoToEddRequest {
        id
        tours {
          id
          type
        }
      }
      ... on GoToIntentBasedOnboarding {
        __typename
        id
        type
      }
      ... on GoToError {
        code
        title
        message
      }
    }
  }
  ${AnalyticsFragment}
  ${BestActionResultV2Fragment}
`;

export default WhereToGo;
